import { render, staticRenderFns } from "./Shipments.vue?vue&type=template&id=3ea7a1e5&scoped=true"
import script from "./Shipments.vue?vue&type=script&lang=js"
export * from "./Shipments.vue?vue&type=script&lang=js"
import style0 from "./Shipments.vue?vue&type=style&index=0&id=3ea7a1e5&prod&scoped=true&lang=css"
import style1 from "./Shipments.vue?vue&type=style&index=1&id=3ea7a1e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea7a1e5",
  null
  
)

export default component.exports